//@ts-ignore
import { tw } from '@careinfo/tailwind';
import {
  Control,
  Controller,
  FieldError,
  Merge,
  FieldErrorsImpl,
} from 'react-hook-form';
import { PhoneInput } from 'react-international-phone';
import './style.css';
import { useEffect, useState } from 'react';

interface Props {
  control: Control<any, any>;
  name: string;
  errors: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  label: string;
  isBold?: boolean;
  labelWidth?: number;
}

const PhoneNumberField = ({ control, name, errors, label }: Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div className={tw`w-full mt-2`}>
      {/* <label className={tw`block text-lg font-semibold mb-1`}>{label}</label> */}
      <label>{label}</label>
      <Controller
        name={name}
        control={control}
        render={({ field }) =>
          field ? (
            <PhoneInput
              className={tw`w-full focus:outline-none bg-[#EEF5F4] mt-1 `}
              inputStyle={{
                backgroundColor: 'inherit',
                border: 'none',
                width: '100%',
              }}
              countrySelectorStyleProps={{
                buttonStyle: { backgroundColor: 'inherit' },
                dropdownStyleProps: {
                  listItemClassName: tw`border`,
                },
              }}
              defaultCountry='np'
              value={field.value || ''}
              onChange={(value) => {
                if (isMounted) {
                  field.onChange(value);
                }
              }}
            />
          ) : null
        }
      />
      {errors && (
        <p className={tw`text-red-500 text-xs mt-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default PhoneNumberField;
